<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1"><p class="quote _idGenParaOverride-1"><span class="italics _idGenCharOverride-1"><br/></span></p>
<p class="Perfect-Center"><a id="u8HtedurPnifSUtgNwRx4u9"></a><a id="uuU5PJNCnJLhfPGdXpmUQIH"></a>BOOK I</p>
<p class="Perfect-Center">The following crimes occurred between</p>
<p class="Perfect-Center">7 May, 2000 - 8 September, 2007</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// BookOne.vue?163d3278